// src/components/LoginModal.js
import React, { useEffect, useRef, useState } from "react";
import { HeaderTrans, LoginTrans } from "../utils/translations";
import { useAppContext } from "../context/AppContext";
import { useAuth0 } from "@auth0/auth0-react";

function LoginModal({ isOpen, onClose }) {
  const modalRef = useRef(null);
  const [isLoginMode, setIsLoginMode] = useState(true);
  const { language } = useAppContext();
  const { loginWithRedirect, logout, isAuthenticated } = useAuth0();

  // Close modal on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-transparent text-left">
      <div
        ref={modalRef}
        className="absolute top-16 right-10 bg-white p-6 rounded-lg shadow-lg w-80"
      >
        <h2 className="text-xl font-semibold mb-4">
          {isLoginMode
            ? LoginTrans[language].loginHeader
            : LoginTrans[language].signupHeader}
        </h2>
        <form className="text-center">
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2 text-left">
              {LoginTrans[language].email}
            </label>
            <input
              type="email"
              className="border rounded-md p-2 w-full"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2 text-left">
              {LoginTrans[language].password}
            </label>
            <input
              type="password"
              className="border rounded-md p-2 w-full"
              required
            />
          </div>
          {!isLoginMode && (
            <div className="mb-4">
              <label className="block text-sm font-medium mb-2 text-left">
                {LoginTrans[language].confirmPassword}
              </label>
              <input
                type="password"
                className="border rounded-md p-2 w-full"
                required
              />
            </div>
          )}
          <button
            type="submit"
            className="bg-pink-500 transition-colors bg-pink rounded-3xl text-white text-md py-1 px-7 hover:bg-brown mt-2 mb-3"
          >
            {isLoginMode
              ? LoginTrans[language].loginHeader
              : LoginTrans[language].signupHeader}
          </button>
        </form>
        <div className="text-center">
          <span className="text-gray-500">
            {isLoginMode
              ? LoginTrans[language].notRegisteredYet
              : LoginTrans[language].alreadySignedUp}{" "}
          </span>
          <button
            onClick={() => setIsLoginMode(!isLoginMode)}
            className="text-pink-500 hover:underline"
          >
            {isLoginMode
              ? LoginTrans[language].signupHeader
              : LoginTrans[language].loginHeader}
          </button>
        </div>
        {isLoginMode && (
          <div className="text-center">
            <button
              type="button"
              className="text-sm text-pink-500 hover:underline"
              onClick={() => {
                /* handle forgot password logic here */
              }}
            >
              {LoginTrans[language].forgotPassword || "Forgot Password?"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default LoginModal;
